<template>
  <div class="c-survey ">
    <div class="container">
      <Modal v-if="isModalOpen" @action="redirect" @cancel="cancelRedirect" />
      <GreetingMission
        class="c-survey__c-greeting"
        :title="
          this.$route.meta.prediction
            ? $t('Completa i pronostici')
            : $t('Completa la Survey!')
        "
        :description="description"
        @action="moveToNextView"
        v-if="currentView === 0 && questions.length > 1"
      >
        <h6 class="c-survey__survey-count text-primary">
          ({{ $t("Numero di") }}
          {{ this.$route.meta.prediction ? $t("pronostici") : $t("domande") }}:
          {{ questions.length }})
        </h6>
      </GreetingMission>
      <SurveyAnswer
        v-if="currentView === 1"
        :showingQuestion="showingQuestion"
        :currentStep="currentQuestion + 1"
        :maxStep="questions.length"
        @onChangeQuestion="onChangeQuestion"
      />
    </div>
  </div>
</template>

<script>
import GreetingMission from "@/components/rebuild/common/GreetingMission";
import SurveyAnswer from "@/components/rebuild/Survey/SurveyAnswer";
import Modal from "@/components/rebuild/Survey/Modal";

import { MissionService } from "@/common/services/api.service";
import { Mutations } from "@/store/global/global.types";
export default {
  name: "Survey",
  components: {
    GreetingMission,
    SurveyAnswer,
    Modal
  },
  data() {
    return {
      description: this.$route.meta.prediction
        ? this.$i18n.t("Rispondi ai pronostici e aspetta i risultati")
        : this.$i18n.t("Rispondi alle domande e riscatta i punti."),
      currentView: 0,
      currentQuestion: 0,
      questions: [],
      answers: [],
      isModalOpen: false,
      isEdited: false
    };
  },
  computed: {
    showingQuestion() {
      return this.questions[this.currentQuestion];
    }
  },
  methods: {
    moveToNextView() {
      this.currentView++;
    },
    redirect() {
      this.isModalOpen = false;
      this.isEdited = false;
      this.$router.push("/dashboard");
    },
    cancelRedirect() {
      this.isModalOpen = false;
    },
    async onChangeQuestion(data) {
      this.questions = this.questions.map(el =>
        el.id === data.question.id ? data.question : el
      );

      if (this.answers.some(el => el.id === data.question.id)) {
        this.answers = this.answers.map(el =>
          el.id === data.question.id
            ? { ...el, answer: data.question.answer }
            : el
        );
      } else {
        this.answers = [
          ...this.answers,
          { id: data.question.id, answer: data.question.answer }
        ];
      }
      this.isEdited = this.answers.some(el => !!el.answer.toString().length);
      if (this.questions.length === data.step) {
        try {
          this.$store.commit(Mutations.SHOW_SPINNER);
          if (this.$route.meta.prediction) {
            await MissionService.sendPredictionAnswers(
              this.$route.params.surveyId,
              {
                answers: this.answers
              }
            );
          } else {
            await MissionService.sendSurveyAnswers(
              this.$route.params.surveyId,
              {
                answers: this.answers
              }
            );
          }
          // eslint-disable-next-line no-empty
        } catch {}
        this.isEdited = false;
        this.$store.commit(Mutations.HIDE_SPINNER);
        this.$router.push("/dashboard");
        return;
      }
      this.currentQuestion = data.step;
    }
  },
  async mounted() {
    try {
      this.$store.commit(Mutations.SHOW_SPINNER);
      let response = null;
      if (this.$route.meta.prediction) {
        response = await MissionService.getPredicitonQuestions(
          this.$route.params.surveyId
        );
      } else {
        response = await MissionService.getSurveyQuestions(
          this.$route.params.surveyId
        );
      }

      const questions = response.data.data
        .map(el => ({ ...el, answer: "" }))
        .sort((a, b) => a.order - b.order);

      this.$store.commit(Mutations.HIDE_SPINNER);
      this.questions = questions;
      if (this.questions.length <= 1) {
        this.currentView++;
      }
    } catch (error) {
      console.log(error);
      this.$store.commit(Mutations.HIDE_SPINNER);
      this.$router.push("/dashboard");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdited) {
      this.isModalOpen = true;
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped>
.c-survey {
  position: relative;
}
.c-survey__c-greeting {
  max-width: 500px;
  margin: 0 auto;
}
.c-survey__survey-count {
  font-weight: bold;
  margin-top: 15px;
  font-size: 20px;
}
</style>
